export default __webpack_public_path__ + "static/xeno-process-02-4e6ee72645249c9989b58b8f58640310.png";